<template>
  <ion-list mode="ios" lines="none">
    <ion-radio-group :value="orderBy">
      <ion-item class="cursor-pointer border-light">
        <ion-label>Sort by Needs Response</ion-label>
        <ion-radio @click="setConvosSort($event)" slot="start" value="needs_response"></ion-radio>
      </ion-item>
      <ion-item class="cursor-pointer border-light">
        <ion-label>Sort Newest to Oldest</ion-label>
        <ion-radio @click="setConvosSort($event)" slot="start" value="DESC"></ion-radio>
      </ion-item>
      <ion-item class="cursor-pointer">
        <ion-label>Sort Oldest to Newest</ion-label>
        <ion-radio @click="setConvosSort($event)" slot="start" value="ASC"></ion-radio>
      </ion-item>
    </ion-radio-group>
  </ion-list>
</template>

<script>
import { EventBus } from "@/services/Events.js";

export default {
  name: "PopoverSortConvos",
  props: {
    orderBy: String,
    orderByDirection: String
  },
  methods: {
    async setConvosSort(event) {
      if (event.target.value === "needs_response") {
        this.orderBy = "needs_response";
        this.orderByDirection = "DESC";
      }

      if (event.target.value === "ASC" || event.target.value === "DESC") {
        this.orderBy = "created_at";
        this.orderByDirection = event.target.value;
      }

      EventBus.$emit("sortConvos", event.target.value);
      this.$ionic.popoverController.dismiss();
    }
  }
};
</script>

<style scoped>
ion-list.list-ios {
  margin-bottom: 0;
}
ion-item {
  padding: 0;
}

ion-label {
  font-weight: 500;
}
.border-light {
  border-bottom: 2px solid var(--ion-color-light);
}
</style>
